

























































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import MainHeader from "@/components/main-header.vue";
import BatchPrinting from "@/components/batch-printing.vue";
import Report from "@/components/template-transfer-pc/report/report.vue";
import Empty from "@/components/empty.vue";
import {
  DelDevice,
  GetContentList,
  GetDeptData,
  GetDeviceAdminOptions,
  GetDeviceList,
  GetDevicePatients,
  GetDeviceReports,
  GetPatientDetail,
  GetPatientList,
  GetRoleData,
  PatchDeptDetail,
  PatchEditUser,
  PatchEditDevice,
  PostAddDept,
  PostAddDevice,
  PostAddUser,
} from "@/request/common";
import axios, { resHandle } from "@/plugins/axios";
import { BuildTree } from "@/utils/base";

@Component({
  components: {
    MainHeader,
    BatchPrinting,
    Report,
    Empty,
  },
})
export default class HomeNew extends Vue {
  private activeModule: any = "org";
  private treeLoading: any = false;
  private reportLoading: any = false;
  private patientSearch: any = "";

  private orgList: any[] = [];
  private orgTreeData: any[] = [];
  private allPatients: any[] = [];
  private treeData: any[] = [];
  private treeProps: any = {
    children: "children",
    label: "label",
  };

  private selectedNodeType: any = "";
  private selectedPatient: any = {};
  private selectedReport: any = {};
  private selectedDeviceId: any = "";

  private deviceMapByOrg: any = {};
  private currentOrgAdmins: any[] = [];
  private adminOptions: any[] = [];
  private roleOptions: any[] = [];
  private selectedOrgForDevice: any = "";
  private reportCountMap: any = {};
  private reportCache: any = {};
  private patientDetailMap: any = {};

  private deptDialogVisible: boolean = false;
  private deptDialogMode: "add" | "edit" = "add";
  private deptForm: any = {
    id: "",
    name: "",
    key: "",
    parent: "",
    nickname: "",
    status: true,
  };
  private deptAdminCredentialStorageKey: string = "home_new_org_admin_credentials";
  private deptAdminCredentialMap: any = {};

  private adminDialogVisible: boolean = false;
  private adminForm: any = {
    dept: "",
    username: "",
    password: "",
    name: "",
    mobile: "",
    gender: 0,
    role: [],
    is_active: true,
  };
  private orgAdminDialogVisible: boolean = false;
  private orgAdminLoading: boolean = false;
  private orgAdminManageOrg: any = {};
  private orgAdminList: any[] = [];
  private orgDeviceDialogVisible: boolean = false;
  private orgDeviceLoading: boolean = false;
  private orgDeviceManageOrg: any = {};
  private orgDeviceList: any[] = [];

  private deviceDialogVisible: boolean = false;
  private deviceDialogLockDept: boolean = false;
  private deviceDialogLockAdmin: boolean = false;
  private deviceDialogFixedDeptName: string = "";
  private deviceDialogFixedAdminLabel: string = "";
  private deviceForm: any = {
    id: "",
    dept: "",
    admin_user: "",
    device_name: "",
    device_id: "",
    baidu_serial_no: "",
    project_name: "",
    remark: "",
    status: true,
  };

  private patientDialogVisible: boolean = false;
  private devicePatientReportDialogVisible: boolean = false;
  private currentDevice: any = {};
  private devicePatientSearch: string = "";
  private devicePatients: any[] = [];
  private deviceReports: any[] = [];

  private get user() {
    return this.$store.state.user || {};
  }

  private get roleInfoList() {
    if (!Array.isArray(this.user.role_info)) {
      return [];
    }
    return this.user.role_info;
  }

  private get isSuperAdmin() {
    const superAdminName = "超级管理员";
    const name = String(this.user?.name || this.user?.username || "");
    if (name === superAdminName || name.toLowerCase().includes("superadmin")) {
      return true;
    }
    return this.roleInfoList.some((role: any) => {
      const roleName = String(role?.name || role?.role_name || role?.title || role || "").toLowerCase();
      return roleName.includes(superAdminName) || roleName.includes("superadmin") || roleName.includes("super admin");
    });
  }

  private get displayOrgs() {
    if (this.isSuperAdmin) {
      return this.orgList;
    }
    const deptInfo = this.user.dept_info || {};
    const deptId = deptInfo.dept_id || deptInfo.id;
    const deptName = String(deptInfo.dept_name || deptInfo.name || "").trim();
    if (!deptId) {
      return [];
    }
    // 顶层锚点部门不作为“可管理机构”展示
    if (deptName === "中医科" || deptName === "运营部") {
      return [];
    }
    return [
      {
        id: String(deptId),
        name: deptName || "当前机构",
      },
    ];
  }

  private get orgMetricCount() {
    if (this.isSuperAdmin) {
      return (this.orgManageList || []).length;
    }
    return (this.displayOrgs || []).length;
  }

  private get allOrgOptions() {
    if (!this.isSuperAdmin) {
      return this.displayOrgs;
    }
    const list: any[] = [];
    const walk = (nodes: any[]) => {
      nodes.forEach((node: any) => {
        list.push({
          id: String(node.id),
          name: node.name,
        });
        if (Array.isArray(node.children) && node.children.length > 0) {
          walk(node.children);
        }
      });
    };
    walk(this.orgTreeData || []);
    return list;
  }

  private get parentOrgOptions() {
    const options = this.allOrgOptions || [];
    return options.filter((item: any) => /^\d+$/.test(String(item.id || "").trim()));
  }

  private get deviceOrgNavList() {
    if (!this.isSuperAdmin) {
      return this.displayOrgs;
    }
    return this.orgManageList || [];
  }

  private get orgManageList() {
    if (!this.isSuperAdmin) {
      return this.orgTreeData || [];
    }
    const chineseDeptAnchors: any[] = [];
    const operationAnchors: any[] = [];
    const result: any[] = [];
    const idMap: any = {};
    const isChineseDept = (name: string) => {
      const text = String(name || "").trim();
      return text === "中医科" || text.includes("中医科");
    };
    const isOperationDept = (name: string) => {
      const text = String(name || "").trim();
      return text === "运营部" || text.includes("运营部");
    };
    const findChineseDeptAnchors = (nodes: any[]) => {
      (nodes || []).forEach((node: any) => {
        if (isChineseDept(node.name)) {
          chineseDeptAnchors.push(node);
        }
        if (Array.isArray(node.children) && node.children.length > 0) {
          findChineseDeptAnchors(node.children);
        }
      });
    };
    const findOperationAnchors = (nodes: any[]) => {
      (nodes || []).forEach((node: any) => {
        if (isOperationDept(node.name)) {
          operationAnchors.push(node);
        }
        if (Array.isArray(node.children) && node.children.length > 0) {
          findOperationAnchors(node.children);
        }
      });
    };
    const collectChildrenAsList = (nodes: any[]) => {
      (nodes || []).forEach((node: any) => {
        const id = String(node.id || "");
        if (id && !idMap[id]) {
          idMap[id] = true;
          result.push({
            ...node,
            children: [],
          });
        }
        if (Array.isArray(node.children) && node.children.length > 0) {
          collectChildrenAsList(node.children);
        }
      });
    };
    findChineseDeptAnchors(this.orgTreeData || []);
    chineseDeptAnchors.forEach((anchor: any) => {
      findOperationAnchors(anchor.children || []);
    });
    operationAnchors.forEach((anchor: any) => {
      collectChildrenAsList(anchor.children || []);
    });
    return result;
  }

  private get filteredPatients() {
    const key = (this.patientSearch || "").trim().toLowerCase();
    if (!key) {
      return this.allPatients;
    }
    return this.allPatients.filter((item: any) => {
      const name = (item.name || "").toLowerCase();
      const uid = (item.uid || "").toLowerCase();
      const phone = (item.phone_number || "").toLowerCase();
      return name.includes(key) || uid.includes(key) || phone.includes(key);
    });
  }

  private get patientMap() {
    const map: any = {};
    this.allPatients.forEach((p: any) => {
      map[p.id] = p;
    });
    return map;
  }

  private get currentDeviceOrgName() {
    const item = this.deviceOrgNavList.find((org: any) => String(org.id) === String(this.selectedOrgForDevice));
    if (item) {
      return item.name;
    }
    const inAll = this.displayOrgs.find((org: any) => String(org.id) === String(this.selectedOrgForDevice));
    if (inAll) {
      return inAll.name;
    }
    const treeNode = this.findOrgNodeById(this.orgTreeData, this.selectedOrgForDevice);
    return treeNode ? treeNode.name : "";
  }

  private get currentOrgDevices() {
    if (!this.selectedOrgForDevice) {
      return [];
    }
    return this.getOrgDevicesFromMap(this.selectedOrgForDevice);
  }

  private get nonAdminOrgId() {
    if (this.displayOrgs.length === 0) {
      return "";
    }
    return String(this.displayOrgs[0].id);
  }

  private get nonAdminDevices() {
    if (!this.nonAdminOrgId) {
      return [];
    }
    return this.getOrgDevicesFromMap(this.nonAdminOrgId);
  }

  private get currentNonAdminDevice() {
    return this.nonAdminDevices.find((device: any) => String(device.id) === String(this.selectedDeviceId)) || null;
  }

  private get nonAdminPatients() {
    const key = (this.patientSearch || "").trim().toLowerCase();
    if (!key) {
      return this.devicePatients;
    }
    return this.devicePatients.filter((item: any) => {
      const name = (item.name || "").toLowerCase();
      const uid = (item.uid || "").toLowerCase();
      const phone = (item.phone_number || "").toLowerCase();
      return name.includes(key) || uid.includes(key) || phone.includes(key);
    });
  }

  private get currentPatientReports() {
    if (!this.selectedPatient || !this.selectedPatient.id) {
      return [];
    }
    const key = this.getReportCacheKey(this.selectedPatient.id, this.isSuperAdmin ? "" : this.selectedDeviceId);
    return this.reportCache[key] || [];
  }

  private get totalDeviceCount() {
    return this.deviceMetricOrgs.reduce((sum: number, org: any) => {
      return sum + this.getOrgDevicesFromMap(org.id).length;
    }, 0);
  }


  private get deviceMetricOrgs() {
    if (this.isSuperAdmin) {
      return this.deviceOrgNavList || [];
    }
    return this.displayOrgs || [];
  }
  private get nonSuperPatientTotal() {
    const devices = this.currentOrgDevices || [];
    return devices.reduce((sum: number, device: any) => {
      const count = Number(device && device.patient_count);
      return sum + (Number.isFinite(count) ? count : 0);
    }, 0);
  }

  private get nonSuperReportTotal() {
    const devices = this.currentOrgDevices || [];
    return devices.reduce((sum: number, device: any) => {
      const count = Number(device && device.report_count);
      return sum + (Number.isFinite(count) ? count : 0);
    }, 0);
  }

  private get patientMetricCount() {
    if (this.isSuperAdmin) {
      return this.allPatients.length;
    }
    return this.nonSuperPatientTotal;
  }

  private get reportMetricCount() {
    if (this.isSuperAdmin) {
      return this.superReportTotal;
    }
    return this.nonSuperReportTotal;
  }

  private get superReportTotal() {
    return this.deviceMetricOrgs.reduce((sum: number, org: any) => {
      const devices = this.getOrgDevicesFromMap(org.id) || [];
      const orgReportTotal = devices.reduce((orgSum: number, device: any) => {
        const count = Number(device && device.report_count);
        return orgSum + (Number.isFinite(count) ? count : 0);
      }, 0);
      return sum + orgReportTotal;
    }, 0);
  }

  private get loadedReportTotal() {
    return Object.keys(this.reportCountMap).reduce((sum: number, patientId: any) => {
      const count = Number(this.reportCountMap[patientId] || 0);
      return sum + count;
    }, 0);
  }

  private get detailTitle() {
    if (this.selectedNodeType === "report") {
      return "报告详情";
    }
    if (this.selectedNodeType === "patient") {
      return "患者报告列表";
    }
    if (this.selectedNodeType === "device") {
      return "设备详情";
    }
    if (this.selectedNodeType === "org") {
      return "机构详情";
    }
    return "请选择左侧节点";
  }

  private async mounted() {
    await this.initPage();
  }

  private async switchModule(module: "org" | "device" | "report") {
    this.activeModule = module;
    if (!this.isSuperAdmin) {
      return;
    }
    if (module === "org") {
      await this.loadOrgList();
      return;
    }
    if (module === "device") {
      if (this.selectedOrgForDevice) {
        await this.selectOrgForDevice({ id: this.selectedOrgForDevice });
      } else if ((this.deviceOrgNavList || []).length > 0) {
        await this.selectOrgForDevice(this.deviceOrgNavList[0]);
      } else {
        this.clearDevicePatientPanel();
      }
    }
  }

  private async initPage() {
    this.treeLoading = true;
    try {
      this.restoreDeptAdminCredentialMap();
      await this.loadRoleOptions();
      await this.loadOrgList();
      if (this.isSuperAdmin) {
        await this.loadAllPatients();
      } else {
        this.allPatients = [];
      }
      await this.loadAllDeviceData();
      if (this.isSuperAdmin) {
        if (this.selectedOrgForDevice) {
          await this.selectOrgForDevice({ id: this.selectedOrgForDevice });
        } else {
          this.clearDevicePatientPanel();
        }
        this.activeModule = "org";
      } else {
        this.activeModule = "device";
        if (this.selectedOrgForDevice) {
          await this.selectOrgForDevice({ id: this.selectedOrgForDevice });
        } else {
          this.clearDevicePatientPanel();
        }
      }
      if (this.isSuperAdmin) {
        this.rebuildReportTree();
      } else {
        this.treeData = [];
      }
    } finally {
      this.treeLoading = false;
    }
  }

  private async loadOrgList() {
    if (!this.isSuperAdmin) {
      this.orgList = this.displayOrgs;
      this.orgTreeData = this.displayOrgs;
      this.selectedOrgForDevice = this.orgList.length > 0 ? String(this.orgList[0].id) : "";
      return;
    }
    try {
      const res: any = await GetDeptData(this, { params: {} });
      const tree = BuildTree(res.data || []);
      this.orgTreeData = this.mapOrgTree(tree || []);
      this.cacheOrgTreeCredentialNodes(this.orgTreeData);
      this.orgList = this.orgTreeData.map((item: any) => ({
        id: item.id,
        name: item.name,
        key: item.key,
        nickname: item.nickname || "",
        admin_username: item.admin_username || "",
        admin_password: item.admin_password || "",
        status: item.status,
        create_datetime: item.create_datetime,
      }));
      if (this.orgList.length === 0) {
        this.orgList = [];
        this.orgTreeData = [];
      }
    } catch (error) {
      this.orgList = [];
      this.orgTreeData = [];
    }
    const deviceOrgs = this.deviceOrgNavList || [];
    this.selectedOrgForDevice = deviceOrgs.length > 0 ? String(deviceOrgs[0].id) : "";
  }

  private mapOrgTree(tree: any[]): any[] {
    return tree.map((item: any) => ({
      ...item,
      id: String(item.id || item.dept_id),
      name: item.name || item.dept_name || `机构${item.id}`,
      key: item.key || "",
      nickname: this.readFirstFilled(item, ["nickname", "nick_name", "dept_nickname", "org_nickname"]),
      admin_username: this.readFirstFilled(item, ["admin_username", "admin_user_name", "operator_admin_username"]),
      admin_password: this.readFirstFilled(item, ["admin_password", "admin_user_password", "operator_admin_password"]),
      status: this.normalizeBoolean(item.status, true),
      create_datetime: item.create_datetime || "",
      children: Array.isArray(item.children) ? this.mapOrgTree(item.children) : [],
    }));
  }

  private normalizeBoolean(value: any, fallback: boolean = true) {
    if (value === true || value === false) {
      return value;
    }
    if (typeof value === "string") {
      const text = value.trim().toLowerCase();
      if (["true", "1", "yes", "y", "on"].includes(text)) {
        return true;
      }
      if (["false", "0", "no", "n", "off"].includes(text)) {
        return false;
      }
    }
    if (typeof value === "number") {
      if (value === 1) {
        return true;
      }
      if (value === 0) {
        return false;
      }
    }
    return fallback;
  }

  private readFirstFilled(source: any, keys: string[]) {
    if (!source || typeof source !== "object") {
      return "";
    }
    for (const key of keys) {
      const value = source[key];
      if (value !== undefined && value !== null && String(value).trim() !== "") {
        return value;
      }
    }
    return "";
  }

  private restoreDeptAdminCredentialMap() {
    try {
      const raw = localStorage.getItem(this.deptAdminCredentialStorageKey) || "{}";
      const parsed = JSON.parse(raw);
      this.deptAdminCredentialMap = parsed && typeof parsed === "object" ? parsed : {};
    } catch (error) {
      this.deptAdminCredentialMap = {};
    }
  }

  private persistDeptAdminCredentialMap() {
    localStorage.setItem(this.deptAdminCredentialStorageKey, JSON.stringify(this.deptAdminCredentialMap || {}));
  }

  private normalizeUsernameKey(username: any) {
    return String(username || "").trim().toLowerCase();
  }

  private getLocalDeptCredential(deptId: any) {
    const id = String(deptId || "");
    if (!id) {
      return {};
    }
    return this.deptAdminCredentialMap[id] || {};
  }

  private getLocalDeptUserPassword(deptId: any, username: any) {
    const local = this.getLocalDeptCredential(deptId);
    const users = local && typeof local.users === "object" ? local.users : {};
    const key = this.normalizeUsernameKey(username);
    if (key && users[key]) {
      return users[key];
    }
    return "";
  }

  private saveLocalDeptCredential(deptId: any, data: any) {
    const id = String(deptId || "");
    if (!id) {
      return;
    }
    const prev = this.getLocalDeptCredential(id);
    const prevUsers = prev && typeof prev.users === "object" ? prev.users : {};
    const users = {
      ...prevUsers,
    };
    const usernameKey = this.normalizeUsernameKey(data && data.username);
    const passwordText = String((data && data.password) || "").trim();
    if (usernameKey && passwordText) {
      users[usernameKey] = passwordText;
    }
    const next = {
      ...prev,
      ...(data.nickname ? { nickname: data.nickname } : {}),
      ...(data.username ? { username: data.username } : {}),
      ...(data.password ? { password: data.password } : {}),
      ...(Object.keys(users).length > 0 ? { users } : {}),
    };
    this.deptAdminCredentialMap = {
      ...this.deptAdminCredentialMap,
      [id]: next,
    };
    this.persistDeptAdminCredentialMap();
  }

  private cacheOrgTreeCredentialNodes(nodes: any[]) {
    if (!Array.isArray(nodes) || nodes.length === 0) {
      return;
    }
    nodes.forEach((node: any) => {
      if (!node) {
        return;
      }
      const deptId = node.id || node.dept_id;
      if (deptId) {
        this.saveLocalDeptCredential(deptId, {
          nickname: this.readFirstFilled(node, ["nickname", "nick_name", "dept_nickname", "org_nickname"]),
          username: this.readFirstFilled(node, ["admin_username", "admin_user_name", "operator_admin_username"]),
          password: this.readFirstFilled(node, ["admin_password", "admin_user_password", "operator_admin_password"]),
        });
      }
      if (Array.isArray(node.children) && node.children.length > 0) {
        this.cacheOrgTreeCredentialNodes(node.children);
      }
    });
  }

  private getOrgNickname(row: any) {
    const local = this.getLocalDeptCredential(row && row.id);
    return row.nickname || row.nick_name || row.dept_nickname || local.nickname || row.name || "/";
  }

  private getOrgAdminUsername(row: any) {
    const local = this.getLocalDeptCredential(row && row.id);
    const fromRow = row.admin_username
      || row.admin_user_name
      || row.operator_admin_username
      || (row.admin_user && (row.admin_user.username || row.admin_user.name));
    return fromRow || local.username || "/";
  }

  private getOrgAdminPassword(row: any) {
    const local = this.getLocalDeptCredential(row && row.id);
    return row.admin_password || row.admin_user_password || row.operator_admin_password || local.password || "/";
  }

  private getOrgAdminListPassword(row: any) {
    if (!row) {
      return "/";
    }
    const fromRow = row.admin_password
      || row.admin_user_password
      || row.operator_admin_password
      || row.password
      || row.password_plain
      || row.initial_password;
    if (fromRow) {
      return fromRow;
    }
    const deptId = String((this.orgAdminManageOrg && this.orgAdminManageOrg.id) || row.dept_id || row.dept || "");
    const byUsername = this.getLocalDeptUserPassword(deptId, row.username);
    if (byUsername) {
      return byUsername;
    }
    const local = this.getLocalDeptCredential(deptId);
    const localUsername = String((local && local.username) || "").trim();
    const rowUsername = String(row.username || "").trim();
    if (localUsername && rowUsername && localUsername === rowUsername) {
      return local.password || "/";
    }
    return "/";
  }

  private getOrgNameById(deptId: any) {
    const id = String(deptId || "");
    if (!id) {
      return "";
    }
    const org = this.displayOrgs.find((item: any) => String(item.id) === id);
    if (org && org.name) {
      return org.name;
    }
    const node = this.findOrgNodeById(this.orgTreeData, id);
    return (node && node.name) || "";
  }

  private getOrgAdminCredentialByDeptId(deptId: any) {
    const id = String(deptId || "");
    if (!id) {
      return {
        username: "/",
        password: "/",
      };
    }
    const node = this.findOrgNodeById(this.orgTreeData, id) || {};
    const row = {
      id,
      ...node,
    };
    return {
      username: this.getOrgAdminUsername(row),
      password: this.getOrgAdminPassword(row),
    };
  }

  private getPreferredAdminForDept(deptId: any) {
    const users = Array.isArray(this.currentOrgAdmins) ? this.currentOrgAdmins : [];
    if (users.length === 0) {
      return null;
    }
    const credential = this.getOrgAdminCredentialByDeptId(deptId);
    const targetUsername = String(credential.username || "").trim();
    if (targetUsername && targetUsername !== "/") {
      const exact = users.find((item: any) => String(item.username || "").trim() === targetUsername);
      if (exact) {
        return exact;
      }
    }
    const active = users.find((item: any) => this.normalizeBoolean(item.is_active, true));
    return active || users[0];
  }

  private async copyTextToClipboard(text: string) {
    const copyText = String(text || "").trim();
    if (!copyText) {
      return false;
    }
    try {
      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(copyText);
        return true;
      }
    } catch (error) {
      // fallback below
    }
    try {
      const textarea = document.createElement("textarea");
      textarea.value = copyText;
      textarea.setAttribute("readonly", "readonly");
      textarea.style.position = "fixed";
      textarea.style.top = "-1000px";
      textarea.style.left = "-1000px";
      document.body.appendChild(textarea);
      textarea.select();
      const copied = document.execCommand("copy");
      document.body.removeChild(textarea);
      return copied;
    } catch (error) {
      return false;
    }
  }

  private async copyDeviceAccess(row: any) {
    const deptId = String((row && row.dept) || (this.orgDeviceManageOrg && this.orgDeviceManageOrg.id) || this.selectedOrgForDevice || "");
    const credential = this.getOrgAdminCredentialByDeptId(deptId);
    let rowAdminUsername = "";
    if (row) {
      rowAdminUsername = String(
        row.admin_username
        || row.admin_user_username
        || (row.admin_user && row.admin_user.username)
        || "",
      ).trim();
      if (!rowAdminUsername && row.admin_user && Array.isArray(this.currentOrgAdmins)) {
        const hit = this.currentOrgAdmins.find((item: any) => String(item.id) === String(row.admin_user));
        rowAdminUsername = String((hit && hit.username) || "").trim();
      }
    }
    const deviceId = String((row && row.device_id) || "/");
    const adminUsername = rowAdminUsername || String(credential.username || "/");
    const adminPassword = String(credential.password || "/");

    const text = `# 设备号唯一
CLOUD_SYNC_DEVICE_ID="${deviceId}"
# 同步云端账号
CLOUD_SYNC_USER_NAME="${adminUsername}"
# 同步云端密码
CLOUD_SYNC_PASSWORD="${adminPassword}"`;
    const copied = await this.copyTextToClipboard(text);
    if (copied) {
      this.$message.success("已复制设备ID与管理员账号密码");
    } else {
      this.$message.warning("复制失败，请手动复制");
    }
  }

  private async downloadDeviceQrCode(row: any) {
    const devicePk = String((row && row.id) || "").trim();
    if (!devicePk) {
      this.$message.warning("设备记录缺失，无法生成小程序码");
      return;
    }
    let resp: any = null;
    try {
      resp = await axios.get(`api/ceping/device/${devicePk}/minip_qrcode/`, {
        responseType: "blob",
      });
    } catch (error) {
      this.$message.warning("请求小程序码失败，请稍后重试");
      return;
    }

    const blob = resp && resp.data ? resp.data : null;
    if (!blob) {
      this.$message.warning("小程序码返回为空");
      return;
    }
    const contentType = String((resp && resp.headers && resp.headers["content-type"]) || "").toLowerCase();
    if (contentType.includes("application/json")) {
      try {
        const text = await blob.text();
        const json = JSON.parse(text || "{}");
        const msg = json.msg || "生成小程序码失败";
        this.$message.warning(msg);
      } catch (error) {
        this.$message.warning("生成小程序码失败");
      }
      return;
    }

    const deptId = String(
      (row && (row.dept || row.dept_id))
      || (this.orgDeviceManageOrg && this.orgDeviceManageOrg.id)
      || this.selectedOrgForDevice
      || "org",
    ).trim();
    const deviceId = String((row && row.device_id) || "device").trim();
    const fileName = `小程序二维码_机构${deptId}_设备${deviceId}.png`;
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);
    this.$message.success("小程序二维码已开始下载");
  }

  private findOrgIdInTreeByForm(name: string, key: string) {
    let result = "";
    const nameText = String(name || "").trim();
    const keyText = String(key || "").trim();
    const walk = (nodes: any[]) => {
      for (const node of nodes || []) {
        const nodeName = String(node.name || "").trim();
        const nodeKey = String(node.key || "").trim();
        if ((keyText && nodeKey && nodeKey === keyText) || (!keyText && nodeName && nodeName === nameText)) {
          result = String(node.id || "");
          return;
        }
        if (Array.isArray(node.children) && node.children.length > 0) {
          walk(node.children);
          if (result) {
            return;
          }
        }
      }
    };
    walk(this.orgTreeData || []);
    return result;
  }

  private getOperationDeptId() {
    let result = "";
    const walk = (nodes: any[]) => {
      for (const node of nodes || []) {
        const name = String(node.name || "").trim();
        if (name === "运营部" || name.includes("运营部")) {
          result = String(node.id || "");
          return;
        }
        if (Array.isArray(node.children) && node.children.length > 0) {
          walk(node.children);
          if (result) {
            return;
          }
        }
      }
    };
    walk(this.orgTreeData || []);
    return result;
  }

  private findOrgNodeById(tree: any[], id: any): any {
    const targetId = String(id || "");
    if (!targetId) {
      return null;
    }
    for (const node of tree) {
      if (String(node.id) === targetId) {
        return node;
      }
      if (Array.isArray(node.children) && node.children.length > 0) {
        const hit = this.findOrgNodeById(node.children, targetId);
        if (hit) {
          return hit;
        }
      }
    }
    return null;
  }

  private async loadRoleOptions() {
    try {
      const res: any = await GetRoleData(this, {
        params: {
          page: 1,
          limit: 200,
          // Backend boolean query parsing is case-sensitive in this endpoint.
          status: "True",
        },
      });
      const roles = res.data || [];
      this.roleOptions = roles.filter((item: any) => this.normalizeBoolean(item.status, true));
    } catch (error) {
      this.roleOptions = [];
    }
  }

  private async loadAllPatients() {
    const list: any[] = [];
    let currentPage = 1;
    let total = 0;
    const limit = 100;
    while (true) {
      const params: any = {
        params: {
          page: currentPage,
          limit,
          ordering: "-update_datetime",
        },
      };
      const res: any = await GetPatientList(this, params);
      const pageData = res.data || [];
      total = Number(res.total || 0);
      list.push(...pageData);
      if (list.length >= total || pageData.length === 0) {
        break;
      }
      currentPage += 1;
    }
    this.allPatients = list;
  }

  private async loadAllDeviceData() {
    this.deviceMapByOrg = {};
    const orgs = this.deviceMetricOrgs;
    for (const org of orgs) {
      await this.loadDevicesByOrg(org.id);
    }
  }

  private async loadDevicesByOrg(orgId: any) {
    const key = String(orgId);
    const list: any[] = [];
    let page = 1;
    let total = 0;
    const limit = 200;
    try {
      while (true) {
        const res: any = await GetDeviceList(this, {
          params: {
            page,
            limit,
            dept: key,
            ordering: "-update_datetime",
          },
        });
        const pageData = res.data || [];
        total = Number(res.total || 0);
        list.push(...pageData);
        if (list.length >= total || pageData.length === 0) {
          break;
        }
        page += 1;
      }
    } catch (error) {
      // ignore and fallback to empty list
    } finally {
      this.$set(this.deviceMapByOrg, key, list);
    }
  }

  private getOrgDevicesFromMap(orgId: any) {
    const key = String(orgId);
    return this.deviceMapByOrg[key] || [];
  }

  private async selectOrgForDevice(org: any) {
    const orgId = String(org.id);
    this.selectedOrgForDevice = orgId;
    if (!this.deviceMapByOrg[orgId]) {
      await this.loadDevicesByOrg(orgId);
    }
    await this.loadAdminsByDept(orgId);
    await this.syncDevicePatientPanelForOrg();
  }

  private clearDevicePatientPanel() {
    this.selectedDeviceId = "";
    this.currentDevice = {};
    this.selectedPatient = {};
    this.selectedReport = {};
    this.devicePatientSearch = "";
    this.devicePatients = [];
    this.deviceReports = [];
  }

  private async selectDeviceForPatientPanel(device: any) {
    if (!device || !device.id) {
      this.clearDevicePatientPanel();
      return;
    }
    this.selectedDeviceId = String(device.id);
    this.currentDevice = device;
    this.selectedPatient = {};
    this.selectedReport = {};
    this.devicePatientSearch = "";
    await this.loadDevicePatients();
  }

  private async syncDevicePatientPanelForOrg() {
    const devices = this.currentOrgDevices || [];
    if (devices.length === 0) {
      this.clearDevicePatientPanel();
      return;
    }
    const hit = devices.find((item: any) => String(item.id) === String(this.selectedDeviceId));
    await this.selectDeviceForPatientPanel(hit || devices[0]);
  }

  private async loadAdminsByDept(deptId: any) {
    if (!deptId) {
      this.currentOrgAdmins = [];
      this.adminOptions = [];
      return [];
    }
    const res: any = await GetDeviceAdminOptions(this, {
      params: {
        dept: deptId,
      },
    });
    const users = res.data || [];
    this.currentOrgAdmins = users;
    this.adminOptions = users;
    return users;
  }

  private openAddDept() {
    const operationDeptId = this.getOperationDeptId();
    if (!operationDeptId) {
      this.$message.warning("未找到“运营部”，请先确认机构层级");
      return;
    }
    this.deptDialogMode = "add";
    this.deptForm = {
      id: "",
      name: "",
      key: "",
      parent: operationDeptId,
      nickname: "",
      status: true,
    };
    this.deptDialogVisible = true;
  }

  private openEditDept(row: any) {
    const local = this.getLocalDeptCredential(row && row.id);
    this.deptDialogMode = "edit";
    this.deptForm = {
      id: row.id,
      name: row.name || "",
      key: row.key || "",
      parent: row.parent ? String(row.parent) : "",
      nickname: row.nickname || row.nick_name || row.dept_nickname || local.nickname || "",
      status: this.normalizeBoolean(row.status, true),
    };
    this.deptDialogVisible = true;
  }

  private async goOrgDevices(row: any) {
    this.orgDeviceManageOrg = row || {};
    this.orgDeviceDialogVisible = true;
    await this.selectOrgForDevice(row);
    await this.loadOrgDeviceList(row && row.id);
  }

  private async loadOrgDeviceList(deptId: any) {
    if (!deptId) {
      this.orgDeviceList = [];
      return;
    }
    this.orgDeviceLoading = true;
    try {
      await this.loadDevicesByOrg(deptId);
      this.orgDeviceList = this.getOrgDevicesFromMap(deptId);
    } finally {
      this.orgDeviceLoading = false;
    }
  }

  private async openCreateDeviceInOrgDialog() {
    const deptId = String((this.orgDeviceManageOrg && this.orgDeviceManageOrg.id) || "");
    if (!deptId) {
      this.$message.warning("请先选择机构");
      return;
    }
    await this.selectOrgForDevice({ id: deptId });
    await this.openCreateDevice();
  }

  private async openOrgAdminManage(row: any) {
    this.orgAdminManageOrg = row || {};
    this.orgAdminDialogVisible = true;
    await this.loadOrgAdminList(row && row.id);
  }

  private async loadOrgAdminList(deptId: any) {
    if (!deptId) {
      this.orgAdminList = [];
      return;
    }
    this.orgAdminLoading = true;
    try {
      const users: any = await this.loadAdminsByDept(deptId);
      this.orgAdminList = users || [];
    } finally {
      this.orgAdminLoading = false;
    }
  }

  private toggleOrgAdminStatus(row: any) {
    const nextActive = !row.is_active;
    const actionName = nextActive ? "启用" : "禁用";
    this.$confirm(`确定${actionName}管理员“${row.name || row.username || row.id}”吗？`, `${actionName}管理员`, {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "保存中...",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      PatchEditUser(this, row.id, { is_active: nextActive }, loading)
        .then(async () => {
          loading.close();
          this.$message.success(`${actionName}成功`);
          await this.loadOrgAdminList(this.orgAdminManageOrg.id);
        })
        .catch(() => {
          loading.close();
        });
    });
  }

  private saveDept() {
    if (!this.deptForm.name) {
      this.$message.warning("请输入机构名称");
      return;
    }
    if (this.deptForm.name==='中医科') {
      this.$message.warning("请换一个名字");
      return;
    }

    const payload: any = {
      name: this.deptForm.name,
      status: this.normalizeBoolean(this.deptForm.status, true),
    };
    if (this.deptForm.key) {
      payload.key = this.deptForm.key;
    }
    if (this.deptDialogMode === "add") {
      const operationDeptId = String(this.deptForm.parent || this.getOperationDeptId() || "").trim();
      if (!/^\d+$/.test(operationDeptId)) {
        this.$message.warning("未找到有效的“运营部”机构，无法新增");
        return;
      }
      payload.parent = Number(operationDeptId);
    }
    const loading = this.$loading({
      lock: true,
      text: "保存中...",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const req = this.deptDialogMode === "edit"
      ? PatchDeptDetail(this, this.deptForm.id, payload, loading)
      : PostAddDept(this, payload, loading);
    req
      .then(async (res: any) => {
        loading.close();
        const isAdd = this.deptDialogMode === "add";
        let deptId = "";
        if (isAdd) {
          deptId = String((res && res.data && (res.data.id || res.data.dept_id)) || "");
        } else {
          deptId = String(this.deptForm.id || "");
        }
        await this.loadOrgList();
        if (!deptId && isAdd) {
          deptId = this.findOrgIdInTreeByForm(this.deptForm.name, this.deptForm.key);
        }
        if (deptId && this.deptForm.nickname) {
          this.saveLocalDeptCredential(deptId, {
            nickname: this.deptForm.nickname,
          });
        }
        this.$message.success(this.deptDialogMode === "edit" ? "机构更新成功" : "新增机构成功");
        this.deptDialogVisible = false;
        await this.loadOrgList();
        await this.loadAllDeviceData();
        if (this.selectedOrgForDevice) {
          await this.loadAdminsByDept(this.selectedOrgForDevice);
        }
        this.rebuildReportTree();
      })
      .catch(() => {
        loading.close();
      });
  }

  private deleteDept(row: any) {
    this.$confirm(`确定删除机构“${row.name || row.id}”吗？`, "删除机构", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "删除中...",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      axios
        .delete(`/api/system/dept/${row.id}/`)
        .then(({ data }) => resHandle(this, data, loading))
        .then(async () => {
          loading.close();
          this.$message.success("机构删除成功");
          await this.loadOrgList();
          await this.loadAllDeviceData();
          if (this.selectedOrgForDevice) {
            await this.loadAdminsByDept(this.selectedOrgForDevice);
          }
          this.rebuildReportTree();
        })
        .catch(() => {
          loading.close();
        });
    });
  }

  private getDefaultAdminRoleId() {
    const roles = Array.isArray(this.roleOptions) ? this.roleOptions : [];
    if (roles.length === 0) {
      return "";
    }
    const exact = roles.find((item: any) => String(item.name || "").trim() === "管理员");
    if (exact && exact.id !== undefined && exact.id !== null) {
      return exact.id;
    }
    const byKey = roles.find((item: any) => String(item.key || "").trim().toLowerCase() === "admin");
    if (byKey && byKey.id !== undefined && byKey.id !== null) {
      return byKey.id;
    }
    const fuzzy = roles.find((item: any) => {
      const name = String(item.name || "").toLowerCase();
      const key = String(item.key || "").toLowerCase();
      return name.includes("管理员") || key.includes("admin");
    });
    if (fuzzy && fuzzy.id !== undefined && fuzzy.id !== null) {
      return fuzzy.id;
    }
    return roles[0].id;
  }

  private async openAddAdmin(deptId?: any) {
    const targetDeptId = String(deptId || this.selectedOrgForDevice || "");
    if (!targetDeptId) {
      this.$message.warning("请先选择机构");
      return;
    }
    await this.loadRoleOptions();
    this.adminForm = {
      dept: targetDeptId,
      username: "",
      password: "",
      name: "",
      mobile: "",
      gender: 0,
      role: [],
      is_active: true,
    };
    const defaultRoleId = this.getDefaultAdminRoleId();
    this.adminForm.role = defaultRoleId ? [defaultRoleId] : [];
    this.adminDialogVisible = true;
  }

  private saveAdmin() {
    if (!this.adminForm.dept) {
      this.$message.warning("请选择机构");
      return;
    }
    if (!this.adminForm.username) {
      this.$message.warning("请输入账号");
      return;
    }
    if (!this.adminForm.password) {
      this.$message.warning("请输入密码");
      return;
    }
    if (!Array.isArray(this.adminForm.role) || this.adminForm.role.length === 0) {
      const defaultRoleId = this.getDefaultAdminRoleId();
      this.adminForm.role = defaultRoleId ? [defaultRoleId] : [];
    }
    if (!Array.isArray(this.adminForm.role) || this.adminForm.role.length === 0) {
      this.$message.warning("未找到“管理员”角色，请先检查角色配置");
      return;
    }
    const payload: any = {
      username: this.adminForm.username,
      password: this.adminForm.password,
      name: this.adminForm.name,
      mobile: this.adminForm.mobile,
      gender: this.adminForm.gender,
      dept: this.adminForm.dept,
      role: this.adminForm.role,
      is_active: true,
      user_type: 0,
    };
    const loading = this.$loading({
      lock: true,
      text: "保存中...",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    PostAddUser(this, payload, loading)
      .then(async () => {
        loading.close();
        this.saveLocalDeptCredential(this.adminForm.dept, {
          username: this.adminForm.username,
          password: this.adminForm.password,
        });
        this.$message.success("新增管理员成功");
        this.adminDialogVisible = false;
        await this.loadAdminsByDept(this.adminForm.dept);
        if (this.orgAdminDialogVisible && String(this.orgAdminManageOrg.id) === String(this.adminForm.dept)) {
          await this.loadOrgAdminList(this.adminForm.dept);
        }
      })
      .catch(() => {
        loading.close();
      });
  }

  private async openCreateDevice() {
    if (!this.selectedOrgForDevice) {
      this.$message.warning("请先选择机构");
      return;
    }
    const deptId = String(this.selectedOrgForDevice);
    await this.loadAdminsByDept(deptId);
    const fixedAdmin = this.getPreferredAdminForDept(deptId);
    if (!fixedAdmin || !fixedAdmin.id) {
      this.$message.warning("当前机构暂无可用管理员，请先新增管理员");
      return;
    }
    this.deviceForm = {
      id: "",
      dept: deptId,
      admin_user: fixedAdmin.id,
      device_name: "",
      device_id: "",
      baidu_serial_no: "",
      project_name: "",
      remark: "",
      status: true,
    };
    this.deviceDialogLockDept = true;
    this.deviceDialogLockAdmin = true;
    this.deviceDialogFixedDeptName = this.getOrgNameById(deptId) || "/";
    this.deviceDialogFixedAdminLabel = `${fixedAdmin.name || fixedAdmin.username || fixedAdmin.id}(${fixedAdmin.username || "/"})`;
    this.deviceDialogVisible = true;
  }

  private async openEditDevice(row: any) {
    this.deviceForm = {
      id: row.id,
      dept: String(row.dept),
      admin_user: row.admin_user,
      device_name: row.device_name,
      device_id: row.device_id,
      baidu_serial_no: row.baidu_serial_no,
      project_name: row.project_name,
      remark: row.remark,
      status: row.status,
    };
    await this.loadAdminsByDept(this.deviceForm.dept);
    this.deviceDialogLockDept = false;
    this.deviceDialogLockAdmin = false;
    this.deviceDialogFixedDeptName = "";
    this.deviceDialogFixedAdminLabel = "";
    this.deviceDialogVisible = true;
  }

  private async onDeviceDeptChange(deptId: any) {
    this.deviceForm.admin_user = "";
    if (deptId) {
      await this.loadAdminsByDept(deptId);
    } else {
      this.adminOptions = [];
    }
  }

  private saveDevice() {
    if (!this.deviceForm.dept) {
      this.$message.warning("请选择机构");
      return;
    }
    if (!this.deviceForm.admin_user) {
      this.$message.warning("请选择管理员");
      return;
    }
    if (!this.deviceForm.device_name) {
      this.$message.warning("请输入设备昵称");
      return;
    }
    const payload: any = {
      dept: this.deviceForm.dept,
      admin_user: this.deviceForm.admin_user,
      device_name: this.deviceForm.device_name,
      baidu_serial_no: this.deviceForm.baidu_serial_no,
      project_name: this.deviceForm.project_name,
      remark: this.deviceForm.remark,
      status: this.deviceForm.status,
    };
    const loading = this.$loading({
      lock: true,
      text: "保存中...",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const req = this.deviceForm.id
      ? PatchEditDevice(this, this.deviceForm.id, payload, loading)
      : PostAddDevice(this, payload, loading);
    req
      .then(async () => {
        loading.close();
        this.$message.success("保存成功");
        this.deviceDialogVisible = false;
        await this.loadDevicesByOrg(this.deviceForm.dept);
        if (String(this.selectedOrgForDevice || "") === String(this.deviceForm.dept || "")) {
          await this.syncDevicePatientPanelForOrg();
        }
        if (
          this.orgDeviceDialogVisible
          && String(this.orgDeviceManageOrg.id || "") === String(this.deviceForm.dept || "")
        ) {
          await this.loadOrgDeviceList(this.orgDeviceManageOrg.id);
        }
        this.rebuildReportTree();
      })
      .catch(() => {
        loading.close();
      });
  }

  private deleteDevice(row: any) {
    this.$confirm("确定删除该设备吗？", "删除设备", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "删除中...",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      DelDevice(this, row.id, loading)
        .then(async () => {
          loading.close();
          this.$message.success("删除成功");
          const targetDeptId = row.dept || this.selectedOrgForDevice;
          await this.loadDevicesByOrg(targetDeptId);
          if (String(this.selectedOrgForDevice || "") === String(targetDeptId || "")) {
            await this.syncDevicePatientPanelForOrg();
          }
          if (
            this.orgDeviceDialogVisible
            && String(this.orgDeviceManageOrg.id || "") === String(targetDeptId || "")
          ) {
            await this.loadOrgDeviceList(this.orgDeviceManageOrg.id);
          }
          this.rebuildReportTree();
        })
        .catch(() => {
          loading.close();
        });
    });
  }

  private async openPatientDialog(row: any) {
    this.currentDevice = row;
    this.selectedDeviceId = String((row && row.id) || "");
    this.selectedPatient = {};
    this.selectedReport = {};
    this.devicePatientSearch = "";
    this.devicePatients = [];
    this.deviceReports = [];
    this.patientDialogVisible = true;
    await this.loadDevicePatients();
    if (this.devicePatients.length > 0) {
      await this.selectPatientInDialog(this.devicePatients[0]);
    }
  }

  private async searchDevicePatients() {
    await this.loadDevicePatients();
  }

  private resolveDeviceIdForPatientSearch() {
    const deviceId = String((this.currentDevice && this.currentDevice.id) || "");
    if (!deviceId) {
      return "";
    }
    const inCurrentOrg = (this.currentOrgDevices || []).some((item: any) => String(item.id) === deviceId);
    const inLegacyDialog = (this.orgDeviceList || []).some((item: any) => String(item.id) === deviceId);
    const inNonAdmin = (this.nonAdminDevices || []).some((item: any) => String(item.id) === deviceId);
    if (this.isSuperAdmin) {
      return inCurrentOrg || inLegacyDialog ? deviceId : "";
    }
    return inNonAdmin ? deviceId : "";
  }

  private async loadDevicePatients() {
    const queryDeviceId = this.resolveDeviceIdForPatientSearch();
    if (!queryDeviceId) {
      this.devicePatients = [];
      this.deviceReports = [];
      return;
    }
    const params: any = {
      params: {
        page: 1,
        limit: 200,
      },
    };
    if (this.devicePatientSearch) {
      params.params.search = this.devicePatientSearch;
    }
    try {
      const res: any = await GetDevicePatients(this, queryDeviceId, params);
      const list = res.data || [];
      this.devicePatients = list.map((item: any) => this.mergePatientBaseInfo(item));
      this.selectedPatient = {};
      this.selectedReport = {};
      this.deviceReports = [];
    } catch (error) {
      this.devicePatients = [];
      this.selectedPatient = {};
      this.selectedReport = {};
      this.deviceReports = [];
    }
  }

  private mergePatientBaseInfo(patient: any) {
    if (!patient || !patient.id) {
      return patient || {};
    }
    const patientId = String(patient.id);
    const fromCache = this.patientDetailMap[patientId] || {};
    const fromList = this.patientMap[patient.id] || {};
    const merged = {
      ...fromList,
      ...fromCache,
      ...patient,
    };
    if (!merged.gender) {
      merged.gender = fromCache.gender || fromList.gender || null;
    }
    if (!merged.birthday) {
      merged.birthday = fromCache.birthday || fromList.birthday || "";
    }
    if (!merged.age && (fromCache.age || fromList.age)) {
      merged.age = fromCache.age || fromList.age;
    }
    return merged;
  }

  private hasBmiData(item: any) {
    if (!item) {
      return false;
    }
    const keys = ["bmi_value", "bmi_category", "height", "weight"];
    return keys.some((key: string) => item[key] !== null && item[key] !== undefined && item[key] !== "");
  }

  private async getJianchaList(patientId: any) {
    this.$store.commit("updateBmi", {});
    if (!patientId) {
      return;
    }
    try {
      const res: any = await GetContentList(this, {
        params: {
          page: 1,
          limit: 200,
          patient_id: patientId,
          ordering: "-create_datetime",
        },
      });
      const list = res.data || [];
      const latest = list.find((item: any) => this.hasBmiData(item));
      if (!latest) {
        return;
      }
      this.$store.commit("updateBmi", {
        bmi_category: latest.bmi_category,
        bmi_value: latest.bmi_value,
        height: latest.height,
        weight: latest.weight,
      });
    } catch (error) {
      this.$store.commit("updateBmi", {});
    }
  }

  private async syncSelectedPatient(patient: any, refreshBmi: boolean = false) {
    if (!patient || !patient.id) {
      this.selectedPatient = {};
      this.$store.commit("updatePatient", {});
      if (refreshBmi) {
        this.$store.commit("updateBmi", {});
      }
      return {};
    }
    let resolved = this.mergePatientBaseInfo(patient);
    if (!resolved.gender || !resolved.birthday) {
      try {
        const detailRes: any = await GetPatientDetail(this, resolved.id);
        const detail = detailRes.data || {};
        resolved = this.mergePatientBaseInfo({
          ...resolved,
          ...detail,
        });
      } catch (error) {
        resolved = this.mergePatientBaseInfo(resolved);
      }
    }
    this.$set(this.patientDetailMap, String(resolved.id), resolved);
    this.selectedPatient = resolved;
    this.$store.commit("updatePatient", resolved);
    if (refreshBmi) {
      await this.getJianchaList(resolved.id);
    }
    return resolved;
  }

  private async openDevicePatientReportDialog(row: any) {
    if (!row || !row.id) {
      return;
    }
    await this.syncSelectedPatient(row, true);
    this.selectedReport = {};
    this.devicePatientReportDialogVisible = true;
  }

  private async selectPatientInDialog(row: any) {
    if (!this.currentDevice.id || !row || !row.id) {
      return;
    }
    const selectedPatient: any = await this.syncSelectedPatient(row, true);
    this.selectedReport = {};
    const params: any = {
      params: {
        page: 1,
        limit: 200,
        patient_id: selectedPatient.id || row.id,
      },
    };
    const res: any = await GetDeviceReports(this, this.currentDevice.id, params);
    this.deviceReports = res.data || [];
  }

  private getReportCacheKey(patientId: any, deviceId: any = "") {
    if (deviceId) {
      return `${deviceId}_${patientId}`;
    }
    return `global_${patientId}`;
  }

  private handlePatientSearch() {
    if (this.isSuperAdmin) {
      this.rebuildReportTree();
      return;
    }
    if (this.selectedPatient && this.selectedPatient.id) {
      const hit = this.nonAdminPatients.some((item: any) => item.id == this.selectedPatient.id);
      if (!hit) {
        this.selectedPatient = {};
        this.selectedReport = {};
        this.selectedNodeType = this.selectedDeviceId ? "device" : "";
      }
    }
  }

  private rebuildReportTree() {
    const patients = this.filteredPatients;
    const nodes = this.displayOrgs.map((org: any) => {
      const orgId = String(org.id);
      const deviceNodes = this.getOrgDevicesFromMap(orgId).map((device: any) => {
        const patientNodes = patients.map((patient: any) => this.buildPatientNode(orgId, device, patient));
        return {
          id: `org_${orgId}_device_${device.id}`,
          type: "device",
          label: `${device.device_name || "未命名设备"}（${patients.length}位患者）`,
          orgId,
          deviceId: device.id,
          device,
          children: patientNodes,
        };
      });
      return {
        id: `org_${orgId}`,
        type: "org",
        label: `${org.name}（${deviceNodes.length}台设备）`,
        orgId,
        org,
        children: deviceNodes,
      };
    });
    this.treeData = nodes;
  }

  private buildPatientNode(orgId: string, device: any, patient: any) {
    const cacheKey = this.getReportCacheKey(patient.id);
    const reportCount = this.reportCountMap[cacheKey];
    const countText = reportCount !== undefined ? `${reportCount}份报告` : "待加载";
    return {
      id: `org_${orgId}_device_${device.id}_patient_${patient.id}`,
      type: "patient",
      patientId: patient.id,
      orgId,
      deviceId: device.id,
      patient,
      loadedReports: !!this.reportCache[cacheKey],
      label: `${patient.name || "未命名患者"}（${countText}）`,
      children: this.reportCache[cacheKey] ? this.buildReportChildren(patient.id, this.reportCache[cacheKey], device.id) : [],
    };
  }

  private buildReportChildren(patientId: any, reports: any[], deviceId: any = "") {
    return reports.map((item: any) => ({
      id: `patient_${patientId}_report_${item.id}`,
      type: "report",
      patientId,
      deviceId,
      reportId: item.id,
      report: item,
      label: this.getReportDisplayName(item),
      isLeaf: true,
      children: [],
    }));
  }

  private getReportDisplayName(item: any) {
    const name = (item.template && item.template.name) || "报告";
    const time = item.collect_time || item.create_datetime || "";
    return time ? `${name}（${time}）` : name;
  }

  private async handleTreeNodeExpand(data: any) {
    if (data.type !== "patient") {
      return;
    }
    await this.loadPatientReports(data.patientId);
  }

  private async handleTreeNodeClick(data: any) {
    this.selectedNodeType = data.type;
    if (data.type === "org" || data.type === "device") {
      this.selectedPatient = {};
      this.selectedReport = {};
      return;
    }
    if (data.type === "patient") {
      await this.syncSelectedPatient(data.patient || {});
      this.selectedReport = {};
      const cacheKey = this.getReportCacheKey(data.patientId);
      if (!this.reportCache[cacheKey]) {
        await this.loadPatientReports(data.patientId);
      }
      return;
    }
    if (data.type === "report") {
      this.selectedReport = data.report || {};
      const patient = this.patientMap[data.patientId] || {};
      if (patient && patient.id) {
        await this.syncSelectedPatient(patient);
      }
    }
  }

  private async loadPatientReports(patientId: any, deviceId: any = "") {
    const cacheKey = this.getReportCacheKey(patientId, deviceId);
    if (this.reportCache[cacheKey]) {
      return;
    }
    this.reportLoading = true;
    try {
      const reports: any[] = [];
      let page = 1;
      const limit = 200;
      let total = 0;
      while (true) {
        let res: any = null;
        if (deviceId) {
          res = await GetDeviceReports(this, deviceId, {
            params: {
              page,
              limit,
              patient_id: patientId,
            },
          });
        } else {
          res = await GetContentList(this, {
            params: {
              page,
              limit,
              patient_id: patientId,
              has_report_type: true,
            },
          });
        }
        const pageData = res.data || [];
        total = Number(res.total || 0);
        reports.push(...pageData);
        if (reports.length >= total || pageData.length === 0) {
          break;
        }
        page += 1;
      }
      this.$set(this.reportCache, cacheKey, reports);
      this.$set(this.reportCountMap, cacheKey, reports.length);
      if (!deviceId) {
        this.patchPatientNodesById(patientId);
      }
      if (this.selectedPatient && this.selectedPatient.id == patientId && reports.length > 0 && !this.selectedReport.id) {
        this.selectedReport = reports[0];
      }
    } finally {
      this.reportLoading = false;
    }
  }

  private patchPatientNodesById(patientId: any) {
    const patchNode = (list: any[]) => {
      list.forEach((node: any) => {
        if (node.type === "patient" && node.patientId == patientId) {
          const cacheKey = this.getReportCacheKey(patientId);
          const reports = this.reportCache[cacheKey] || [];
          node.loadedReports = true;
          node.label = `${node.patient.name || "未命名患者"}（${reports.length}份报告）`;
          node.children = this.buildReportChildren(patientId, reports, node.deviceId);
        }
        if (node.children && node.children.length > 0) {
          patchNode(node.children);
        }
      });
    };
    patchNode(this.treeData);
    this.treeData = [...this.treeData];
  }

  private async selectReportFromList(item: any, patient: any) {
    this.selectedNodeType = "report";
    this.selectedReport = item;
    if (patient && patient.id) {
      await this.syncSelectedPatient(patient);
    }
  }

  private async initNonAdminWorkspace() {
    const devices = this.nonAdminDevices;
    if (devices.length > 0) {
      const hit = devices.some((device: any) => String(device.id) === String(this.selectedDeviceId));
      if (!hit) {
        this.selectedDeviceId = String(devices[0].id);
      }
      if (!this.selectedNodeType) {
        this.selectedNodeType = "device";
      }
      await this.loadPatientsForSelectedDevice();
    } else {
      this.selectedDeviceId = "";
      this.selectedPatient = {};
      this.selectedReport = {};
      this.selectedNodeType = "";
      this.devicePatients = [];
    }
  }

  private async selectNonAdminDevice(device: any) {
    this.selectedDeviceId = String(device.id);
    this.selectedNodeType = "device";
    this.selectedPatient = {};
    this.selectedReport = {};
    await this.loadPatientsForSelectedDevice();
  }

  private async loadPatientsForSelectedDevice() {
    if (!this.selectedDeviceId) {
      this.devicePatients = [];
      return;
    }
    const res: any = await GetDevicePatients(this, this.selectedDeviceId, {
      params: {
        page: 1,
        limit: 200,
      },
    });
    const list = res.data || [];
    this.devicePatients = list.map((item: any) => this.mergePatientBaseInfo(item));
  }

  private async selectNonAdminPatient(patient: any) {
    const selectedPatient: any = await this.syncSelectedPatient(patient);
    this.selectedReport = {};
    this.selectedNodeType = "patient";
    if (selectedPatient && selectedPatient.id) {
      await this.loadPatientReports(selectedPatient.id, this.selectedDeviceId);
    }
  }

  private getPatientReportCountText(patient: any) {
    if (typeof patient.report_count === "number") {
      return `${patient.report_count}份报告`;
    }
    const cacheKey = this.getReportCacheKey(patient.id, this.selectedDeviceId);
    const count = this.reportCountMap[cacheKey];
    if (count === undefined) {
      return "待加载";
    }
    return `${count}份报告`;
  }

  private noopChangeData() {}
}
